import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ApplicationRouter, Route } from '@aviv-unified-frontend/runtime/router';
import { Head } from '@components/Head';
import { BrandConfigurationProvider } from './contexts/brandConfiguration/provider';
import { Brand } from './brands';
const Template = Brand.template;
export const App = () => {
    return (_jsxs(BrandConfigurationProvider, { value: Brand, children: [_jsx(Head, {}), _jsx(ApplicationRouter, { children: _jsx(Route, { path: "/", element: _jsx(Template, {}) }) })] }));
};
